import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../components-v2/Theme/theme';
import { CssSelectors } from '../../../../../styles/styles';
import { TIMELINE_CONTENT_OFFSET } from '../TimeLine/styles';

const { spacing, colors, typography } = THEME;

const indicator = (color: string) =>
	CssSelectors.allChildren({ height: 8, width: 8, borderRadius: '50%', backgroundColor: color }, '.indicator');

export const styleSheet = StyleSheet.create({
	container: {
		alignItems: 'center',
		borderRadius: THEME.common.borderRadius,
		color: colors.text.main,
		display: 'flex',
		flexWrap: 'wrap',
		fontSize: typography.fontSizes.sm,
		gap: spacing.xs,
		// Lines the strip up with the timeline's date headers so the time gutter below it stays clear.
		marginLeft: TIMELINE_CONTENT_OFFSET,
		padding: `${spacing.xs}px ${spacing.sm}px`,
	},
	containerHealthy: {
		backgroundColor: colors.success.light,
		...indicator(colors.success.dark),
	},
	containerUnhealthy: {
		backgroundColor: colors.danger.light,
		...indicator(colors.danger.dark),
	},
	containerNeutral: {
		backgroundColor: colors.hover.light,
		...indicator(colors.hover.dark),
	},
	metric: {
		alignItems: 'center',
		display: 'flex',
		gap: spacing.xs,
	},
	separator: {
		color: colors.text.light,
	},
	value: {
		fontWeight: typography.fontWeights.bold,
	},
	infoIcon: {
		alignItems: 'center',
		display: 'flex',
		marginLeft: spacing.xs,
	},
	tooltip: {
		maxWidth: 420,
		whiteSpace: 'normal',
	},
	// The counts read as one unit, so they get their own line rather than wrapping a stray "of N"
	// onto the next; the width above is what lets them fit.
	tooltipCounts: {
		whiteSpace: 'nowrap',
	},
	tooltipDisclaimer: {
		color: colors.text.light,
		marginTop: spacing.xs,
	},
});
